import script from "./side-nav.vue?vue&type=script&setup=true&lang=js"
export * from "./side-nav.vue?vue&type=script&setup=true&lang=js"

import "./side-nav.vue?vue&type=style&index=0&id=d7030258&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7030258"]])

export default __exports__